// extracted by mini-css-extract-plugin
export default {"Carouselwrapper":"Carousel_Carouselwrapper__mUB2q"};